// React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { cartState, orderState, paymentData } from "../../atom/menu";
// Components
import Dial from "../../components/common/Dial";
// Assets
import { menuListData } from "../../assets/menuListData";
import { NPayType, ProductType } from "../../assets/Type";

function PaymentNPay() {
  // 분할 결제 화면

  const navigate = useNavigate();
  // Recoil State
  const cartData = useRecoilValue(cartState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [payment, setPayment] = useRecoilState(paymentData);
  // useState
  const [divisionType, setDivisionType] = useState<boolean>(true);
  // true = 횟수입력 / false = 금액입력
  const [count, setCount] = useState<number>(3);
  const [count2, setCount2] = useState<string>("0");
  const [isCard, setIsCard] = useState(false);
  const [npayType, setNpayType] = useState(true);
  // true = 상품으로 결제 / false = 금액으로 결제
  const [selectMenu, SetSelectMenu] = useState<ProductType[] | null>(null);
  const [divisionList, SetDivisionList] = useState<NPayType[] | null>(null);

  // Function
  useEffect(() => {
    if (!npayType) {
      if (divisionType) {
        const list = [];
        const indiviualAmount = Math.ceil(calcTotalAmount(cartData) / count);
        for (var i = 0; i < count; i++) {
          list.push({
            payType: "금액-횟수",
            amount: indiviualAmount,
          });
        }
        SetDivisionList(list);
      }
    }
  }, [npayType, count]);

  const addCount = () => {
    setCount(count + 1);
  };

  const minusCount = () => {
    if (count > 2) {
      setCount(count - 1);
    }
  };

  const nextPage = () => {
    let prev;
    if (npayType) {
      prev = {
        ...payment,
        payType: "npay",
        nPay: [
          {
            payType: "상품",
            amount: calcTotalAmount(selectMenu)!,
          },
          {
            payType: "상품",
            amount: calcTotalAmount(cartData)! - calcTotalAmount(selectMenu)!,
          },
        ],
      };
      setPayment(prev);
    } else {
      if (divisionType) {
        // 횟수로 나누기
        prev = { ...payment, payType: "npay", nPay: divisionList };
        setPayment(prev);
      } else {
        // 금액으로 나누기
        prev = {
          ...payment,
          payType: "npay",
          nPay: [
            {
              payType: "금액",
              amount: Number(count2),
            },
            {
              payType: "금액",
              amount: calcTotalAmount(cartData) - Number(count2),
            },
          ],
        };
        setPayment(prev);
      }
    }
    const prevArray = [...orderData!.orderData];
    const curOrderData = { ...orderData!.orderData[0], payment: prev };
    prevArray.splice(0, 1, curOrderData);
    setOrderData({ ...orderData!, orderData: [...prevArray] });

    setIsCard(true);
    setTimeout(() => {
      navigate("/menu/order/payment/success");
    }, 3000);
  };

  function calcTotalAmount(list: ProductType[] | null) {
    if (list) {
      let amt = 0 as number;
      let option = 0 as number;
      list.reduce((acc, cur) => {
        amt = acc + cur.price * cur.ea;
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
        }
        return amt;
      }, amt);
      let total = (amt + option) as number;
      return total;
    } else return 0;
  }
  function calcTotalPrice(data: ProductType | null) {
    if (data) {
      let amt = 0 as number;
      let option = 0 as number;
      amt = data.price;
      if (data.option) {
        data.option.reduce((acc, cur) => {
          option = acc + cur.price * cur.ea;
          return option;
        }, option);
      }
      return (amt + option) * data.ea;
    } else return 0;
  }

  const meneClickEvent = (menu: ProductType) => {
    if (selectMenu) {
      const arr = [...selectMenu];
      if (selectMenu.find((v) => v.name === menu.name)) {
        // 있으면 삭제
        arr.splice(
          selectMenu.findIndex((v) => v.name === menu.name),
          1
        );
        SetSelectMenu(arr);
      } else {
        // 없으면 추가
        arr.push(menu);
        SetSelectMenu(arr);
      }
    } else {
      // 처음엔 무조건 추가
      SetSelectMenu([menu]);
    }
  };

  return (
    <>
      <div className='payment-cash-wrap' style={{ backgroundColor: "#eee" }}>
        <img
          className='absolute-logo'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
          style={{ width: 158 }}
        />
        <div className='flex row' style={{ height: "calc(100% - 129px)" }}>
          <div
            className='payment-cash-left'
            style={{ padding: "158px 50px 40px 50px " }}
          >
            <div className='flex col' style={{ gap: 38 }}>
              <div className='TO-title-2'>
                {npayType
                  ? "결제할 상품을 선택해 주세요"
                  : "결제 금액을 확인 후 선택해주세요"}
              </div>
              <div className='flex center h-auto' style={{ gap: 8 }}>
                {npayType ? (
                  <>
                    <div className='npay-category-box-active TO-button-2'>
                      상품으로 결제
                    </div>
                    <div
                      className='npay-category-box TO-button-2 '
                      onClick={() => {
                        setNpayType(false);
                      }}
                    >
                      금액으로 결제
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className='npay-category-box TO-button-2'
                      onClick={() => {
                        setNpayType(true);
                      }}
                    >
                      상품으로 결제
                    </div>
                    <div className='npay-category-box-active TO-button-2'>
                      금액으로 결제
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='flex col text-color-gray-5 h-auto'>
              {npayType ? (
                <>
                  <div className='pay-row' style={{ padding: 0 }}>
                    <div className='TO-body-3'>분할 결제 1</div>
                    <div className='TO-body-3'>
                      {calcTotalAmount(selectMenu)?.toLocaleString()}원
                    </div>
                  </div>
                  <div className='pay-row' style={{ padding: 0 }}>
                    <div className='TO-body-3'>분할 결제 2</div>
                    <div className='TO-body-3'>
                      {(
                        calcTotalAmount(cartData) - calcTotalAmount(selectMenu)
                      ).toLocaleString()}
                      원
                    </div>
                  </div>
                  <div className='pay-row' style={{ padding: 0, marginTop: 4 }}>
                    <div className='TO-title-2-small text-color-gray-6'>
                      총 금액
                    </div>
                    <div className='TO-title-2-small text-color-gray'>
                      {calcTotalAmount(cartData).toLocaleString()}원
                    </div>
                  </div>
                </>
              ) : (
                <div
                  className='pay-row h-auto'
                  style={{ padding: 0, marginTop: 4 }}
                >
                  <div className='TO-title-2-small text-color-gray-6'>
                    총 금액
                  </div>
                  <div className='TO-title-2-small text-color-gray'>
                    {calcTotalAmount(cartData).toLocaleString()}원
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='payment-cash-right'>
            {npayType ? (
              <div className='flex col scroll' style={{ gap: "4px" }}>
                {cartData?.map((v) => {
                  return (
                    <div
                      className='npay-menu-row'
                      onClick={() => {
                        meneClickEvent(v);
                      }}
                    >
                      {menuListData.find((link) => link.name === v.name) && (
                        <img
                          className='menu-img'
                          src={`/assets/images/menuimg/${
                            menuListData[
                              menuListData.findIndex(
                                (link) => link.name === v.name
                              )
                            ].img
                          }`}
                          alt='menu'
                        />
                      )}
                      <div className='npay-menu-inner-warp'>
                        {selectMenu &&
                        selectMenu!.findIndex((menu) => {
                          return menu.name === v.name;
                        }) > -1 ? (
                          <img
                            className='check-box'
                            src={"/assets/images/menu/checkbox-full.svg"}
                            alt='check box'
                          />
                        ) : (
                          <img
                            className='check-box'
                            src={"/assets/images/menu/checkbox.svg"}
                            alt='check box'
                          />
                        )}
                        <div className='flex col'>
                          <div
                            className='TO-button-2 text-color-gray-5 text-elipsis-1'
                            style={{ maxWidth: 300 }}
                          >
                            {v.name}
                          </div>
                          <div
                            className='TO-option-2 text-color-gray-6 text-elipsis-1'
                            style={{ maxWidth: 300 }}
                          >
                            {v.option &&
                              v.option.map((option, idx) => {
                                return idx === 0
                                  ? option.name
                                  : "/" + option.name;
                              })}
                          </div>
                          <div
                            className='TO-title-2'
                            style={{ alignSelf: "flex-end" }}
                          >
                            {calcTotalPrice(v).toLocaleString()} 원
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className='flex col' style={{ gap: "32px" }}>
                <div className='pay-row' style={{ padding: 0, marginTop: 4 }}>
                  <div className='TO-title-2-small text-color-gray-6'>
                    남은 금액
                  </div>
                  <div className='TO-title-2-small text-color-gray'>
                    {calcTotalAmount(cartData).toLocaleString()}원
                  </div>
                </div>

                <div
                  className='flex row justify-content-end w-100'
                  style={{ gap: 8, marginTop: 8, height: 64 }}
                >
                  {divisionType ? (
                    <>
                      <div
                        className='control-btn-small'
                        onClick={() => {
                          minusCount();
                        }}
                      >
                        {count === 0 ? (
                          <img
                            src={`/assets/images/menu/minus.svg`}
                            alt={"minuse button"}
                          />
                        ) : (
                          <img
                            src={`/assets/images/menu/minus2.svg`}
                            alt={"minuse button"}
                          />
                        )}
                      </div>
                      <div className='control-count-small TO-price-2 text-color-black'>
                        {Number(count)}
                      </div>
                      <div
                        className='control-btn-small'
                        onClick={() => {
                          addCount();
                        }}
                      >
                        <img
                          src={`/assets/images/menu/plus.svg`}
                          alt={"plus button"}
                        />
                      </div>
                      <div
                        className='TO-body-2 text-color-gray'
                        style={{ minWidth: "fit-content" }}
                      >
                        회로 나누기
                      </div>
                    </>
                  ) : (
                    <div className='TO-body-2 text-color-gray'>
                      <span
                        className='TO-price-2'
                        style={{ color: "#010101", marginRight: 16 }}
                      >
                        {Number(count2).toLocaleString()}
                      </span>
                      원 결제하기
                    </div>
                  )}

                  <div
                    className='basic-btn white T26M pointer'
                    style={{
                      maxWidth: 147,
                      height: 64,
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      setDivisionType(!divisionType);
                    }}
                  >
                    {divisionType ? "금액입력" : "횟수입력"}
                  </div>
                </div>
                <>
                  {divisionType ? (
                    <div className='flex col scroll' style={{ gap: 4 }}>
                      {divisionList?.map((v) => (
                        <div className='npay-indiviual-box'>
                          <span className='TO-title-3 text-color-gray'>
                            카드결제
                          </span>
                          <span className='TO-title-2 text-color-gray-3'>
                            {v.amount.toLocaleString()}원
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Dial
                      type={"all-delete"}
                      value={count2}
                      action={setCount2}
                    />
                  )}
                </>
              </div>
            )}
          </div>
        </div>
        <div
          className='menu-intro-button'
          style={{
            padding: "16px 24px",
            justifyContent: "flex-start",
            backgroundColor: "#EEEEEE",
          }}
        >
          {divisionType && <div className='botton-bg-gradation pointer'></div>}
          <div
            className='basic-btn white TO-button-1'
            style={{ maxWidth: 208 }}
            onClick={() => {
              navigate("/menu");
            }}
          >
            이전으로
          </div>
          {npayType ? (
            selectMenu &&
            selectMenu?.length > 0 && (
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ maxWidth: "100%" }}
                onClick={() => {
                  nextPage();
                }}
              >
                {selectMenu.length}개 결제하기
              </div>
            )
          ) : divisionType ? (
            <div
              className='basic-btn TO-button-1 pointer'
              style={{ maxWidth: "100%" }}
              onClick={() => {
                nextPage();
              }}
            >
              {count}회 결제하기
            </div>
          ) : (
            <div
              className='basic-btn TO-button-1 pointer'
              style={{ maxWidth: "100%" }}
              onClick={() => {
                nextPage();
              }}
            >
              {Number(count2).toLocaleString()}원 결제하기
            </div>
          )}
        </div>
      </div>
      {isCard && (
        <div
          className='menu-popup-bg'
          style={{ backgroundColor: "rgba(0, 0, 0, 0.7", zIndex: 99 }}
        >
          <div
            className='menu-popup-inner-wrap'
            style={{ width: 885, backgroundColor: "#eaeaea" }}
          >
            <div className='flex col center' style={{ padding: 62, gap: 32 }}>
              <img
                src={"/assets/images/menu/creditcard.svg"}
                alt='creditcard'
              />
              <div
                className='TO-title-1'
                style={{ textAlign: "center", color: "#010101" }}
              >
                카드를 리더기에 꽂아주세요
              </div>
              <div className='flex row center' style={{ gap: 16 }}>
                <img
                  src={"/assets/images/menu/timer.png"}
                  alt='timer'
                  style={{ width: 40 }}
                />
                <div className='TO-body-3'>결제시도중입니다...</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default PaymentNPay;
